module.exports = __webpack_public_path__ + "assets/img/3_1220_big.e0ee8eb3.jpg";